module.exports = __webpack_public_path__ + "static/media/IM.319888d5.png";